import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { MarqueeStrip } from "@/components/site/MarqueeStrip";
import { Businesses } from "@/components/site/Businesses";
import { Fleet } from "@/components/site/Fleet";
import { Gallery } from "@/components/site/Gallery";
import { Booking } from "@/components/site/Booking";
import { Testimonials } from "@/components/site/Testimonials";
import { ContactLocation } from "@/components/site/ContactLocation";
import { FloatingCTAs } from "@/components/site/FloatingCTAs";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain min-h-screen bg-asphalt text-[#f5f5f0] font-hind">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Businesses />
        <Fleet />
        <Gallery />
        <Booking />
        <Testimonials />
        <ContactLocation />
      </main>
      <Footer />
      <FloatingCTAs />
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
